import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { UIRouter }                 from '@uirouter/core';
import { TranslateService }         from '@ngx-translate/core';

import { CompanyService }         from '../companies/company.service';
import { ConfirmService }         from '../messages/confirm/confirm.service';
import { FranchiseAccountsModel } from './typings/franchise.accounts';
import { FranchiseModel }         from './typings/franchise';
import { FranchisesService }      from './franchises.service';
import { MessagesService }        from '../messages/messages.service';

@Component({
  selector   : 'wor-franchise',
  template: require('./franchise.component.html')
})
export class FranchiseComponent implements OnInit {
  @Input() accounts = {} as FranchiseAccountsModel;
  @Input() franchise: FranchiseModel;

  key  = 'id';
  name = 'name';

  constructor (
    private companyService   : CompanyService,
    private confirmService   : ConfirmService,
    private franchisesService: FranchisesService,
    private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService
  ) {}

  ngOnInit () : void {
    this.assignKeys();
  }

  assignKeys () : void {
    if ( this.companyService.hasIntegration('xero') ) {
      this.key  = 'code';
      this.name = 'description';
    }
    else if ( this.companyService.hasIntegration('myob') ) {
      this.key  = 'UID';
      this.name = 'Name';
    }
    else {
      this.key  = 'id';
      this.name = 'name';
    }
  }

  delete () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_VEHICLE_FRANCHISE_GROUP'))
    .then(() => this.franchisesService.delete(this.franchise))
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.VEHICLE_GROUP_FRANCHISE'), 'success');

      this.router.stateService.go('app.franchise-settings');
    })
    .catch(error => this.messagesService.error(error));
  }

  save ( form : NgForm ) : void {
    this.franchisesService.save(this.franchise)
    .then(( franchise : FranchiseModel ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.go('app.franchise', {
        id: franchise.id
      }, {
        reload: !!this.franchise.id
      });
    })
    .catch(error => this.messagesService.error(error));
  }
}
